import { CreateItineraryDto, ItineraryFormDto, RowItineraryDto, UpdateItineraryDto } from "@/dtos";
import { Itinerary } from "@/entities";
import { getTripPatternOrientationLabel } from "@/helpers/options";
import { getAdministratorFromLocalStorage, parseToTimeFromTimeSeconds, parseToUtcTime } from "@/helpers/utilities";

export const formatCreateItineraryDto = (form: ItineraryFormDto, lastItinerary: Itinerary, isOutbound: boolean, itinerary_id?: number): CreateItineraryDto => {
    const createItineraryDto: CreateItineraryDto = {
        schedule: form.schedule,
        turn: form.turn,
        trip_pattern: (isOutbound) ? form.outboundTrip.trip_pattern : form.returnTrip.trip_pattern,
        hour: (isOutbound) ? parseToUtcTime(form.outboundTrip.hour) : parseToUtcTime(form.returnTrip.hour),
        place: {
            origin: {
                id: (isOutbound) ? form.outboundTrip.origin.id : form.returnTrip.origin.id,
                name: (isOutbound) ? form.outboundTrip.origin.name : form.returnTrip.origin.name 
            },
            destiny: {
                id: (isOutbound) ? form.outboundTrip.destiny.id : form.returnTrip.destiny.id,
                name: (isOutbound) ? form.outboundTrip.destiny.name : form.returnTrip.destiny.name
            },
            orientation: (isOutbound) ? form.outboundTrip.trip_pattern.orientation : form.returnTrip.trip_pattern.orientation 
        },
        lap_num: (isOutbound) ? ((lastItinerary) ? lastItinerary.lap_num + 1 : 1) : lastItinerary.lap_num,
        trip_num: (lastItinerary) ? lastItinerary.trip_num + 1 : 1,
        itinerary: (itinerary_id) ? { id: itinerary_id } as Itinerary : undefined
    }

    return createItineraryDto;
}

export const formatUpdateItineraryDto = (form: ItineraryFormDto): UpdateItineraryDto => {
    const updateItineraryDto = {
        schedule: form.schedule,
        turn: form.turn,
        trip_pattern: form.outboundTrip.trip_pattern,
        place: {
            origin: {
                id:  form.outboundTrip.origin.id,
                name: form.outboundTrip.origin.name
            },
            destiny: {
                id:  form.outboundTrip.destiny.id,
                name: form.outboundTrip.destiny.name
            },
            orientation: form.outboundTrip.trip_pattern.orientation
        },
        hour: parseToUtcTime(form.outboundTrip.hour)
    } as UpdateItineraryDto;

    return updateItineraryDto;
}

export const formatRowItineraryDto = (itineraries: Itinerary[]): RowItineraryDto[] => {
    return itineraries.map((x) => {
        const row: RowItineraryDto = {
            ...x,
            hour_label: parseToTimeFromTimeSeconds(x.hour),
            turn_label: x.turn.name,
            schedule_label: x.schedule.short_name,
            trip_pattern_label: x.trip_pattern.name,
            active: (x.is_active) ? 'Activo' : 'Inactivo',
            orientation_label: getTripPatternOrientationLabel(x.trip_pattern.orientation),
            place_origin: x.place?.origin?.name ?? '', 
            place_destiny: x.place?.destiny?.name ?? '', 
        }

        return row;
    });
}